(function () {
  function log(...args) {
    console.log('[Province Filter]', ...args);
  }

  function getConfig() {
    return (window.theme && window.theme.provinceFiltering) || {};
  }

  function isEnabled() {
    const config = getConfig();
    return Boolean(config.enabled);
  }

  function isOntarioVisitor() {
    return document.body.dataset.province === 'ON';
  }

  function applyProvinceNav() {
    // Pending guard: while the province is unresolved (popup mode, before the visitor has
    // chosen), do NOT toggle menus — leave the server-rendered default. This only triggers
    // on the 'pending' state, so IP mode (which never sets 'pending') is unaffected.
    if (document.body.dataset.provinceState === 'pending') {
      log('applyProvinceNav: province pending (awaiting popup choice) — deferring');
      return;
    }

    const provinceMenus = document.querySelectorAll('main-menu[data-province-menu]');
    if (!provinceMenus.length) {
      log('applyProvinceNav: no province menus found');
      return;
    }

    const isMobile = !window.matchMedia('(min-width: 750px)').matches;
    const wasMenuOpen = isMobile && document.body.classList.contains('main-menu-open');

    if (wasMenuOpen) {
      window.location.reload();
      return;
    }

    const activeMenu = isOntarioVisitor() ? 'ontario' : 'other';
    log('applyProvinceNav: province=', document.body.dataset.province, '→ menu=', activeMenu);
    provinceMenus.forEach((menu) => {
      const isActive = menu.dataset.provinceMenu === activeMenu;
      menu.style.display = isActive ? '' : 'none';
      menu.setAttribute('aria-hidden', String(!isActive));
    });
  }

  function applyProvinceSections() {
    if (document.body.dataset.provinceState === 'pending') {
      log('applyProvinceSections: province pending — deferring');
      return;
    }

    const sections = document.querySelectorAll('[data-province-section]');
    if (!sections.length) return;

    const province = document.body.dataset.province;
    const isNonCanada = !province;
    const activeProvince = isNonCanada ? 'non_canada' : (isOntarioVisitor() ? 'ontario' : 'other');
    log('applyProvinceSections: province=', province, '→ showing sections for', activeProvince);
    sections.forEach((el) => {
      const sectionVisibility = el.dataset.provinceSection;
      const shouldShow = sectionVisibility === activeProvince;
      const wrapper = el.closest('.shopify-section') || el;
      wrapper.style.display = shouldShow ? '' : 'none';
      log('  section', wrapper.id || '?', 'visibility=', sectionVisibility, 'show=', shouldShow);
    });
  }

  function applyCollectionTagFilter() {
    const facetFilters = document.querySelector('facet-filters');
    if (!facetFilters) return;

    const tagValue = isOntarioVisitor() ? 'PROV' : 'FED';
    log('applyCollectionTagFilter: auto-applying tag', tagValue);
    const form = facetFilters.querySelector('form') || document;

    // Uncheck all existing tag filters first (avoid double tags when province changes).
    // const allTagInputs = form.querySelectorAll('input[name*="tag"]');
    const allTagInputs = form.querySelectorAll('input[name*="filter.p.m.custom.supported_provinces"]');
    allTagInputs.forEach((input) => {
      input.checked = false;
    });

    // let tagCheckbox = form.querySelector(`input[name="filter.p.tag"][value="${tagValue}"]`);
    // if (!tagCheckbox) {
    //   tagCheckbox = form.querySelector(`input[value="${tagValue}"]`);
    // }

    // if (!tagCheckbox) {
    //   log('applyCollectionTagFilter: no tag checkbox for', tagValue, '→ show banner');
    //   updateCollectionBanner(0);
    //   return;
    // }

    // tagCheckbox.checked = true;
    // tagCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
    let provincesCheckbox = form.querySelector(`input[name="filter.p.m.custom.supported_provinces"][value="${tagValue}"]`);
    // if (!provincesCheckbox) {
    //   provincesCheckbox = form.querySelector(`input[value="${tagValue}"]`);
    // }

    if (!provincesCheckbox) {
      // No supported_provinces facet on the page (filter not enabled in Search & Discovery,
      // e.g. the QC store). Degrade gracefully — leave the catalog as-is instead of hiding it
      // behind the empty-results banner. Enable the metafield filter in S&D to activate FED/PROV.
      log('applyCollectionTagFilter: no supported_provinces facet for', tagValue, '— enable it in Search & Discovery; skipping (catalog left as-is)');
      return;
    }

    log('applyCollectionTagFilter: provinces checkbox found for', tagValue);
    provincesCheckbox.checked = true;
    provincesCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
    updateCollectionBanner();
  }

  function updateCollectionBanner(productCount) {
    const banner = document.querySelector('.js-province-banner');
    if (!banner) return;

    const resultsEl = document.getElementById('filter-results');
    const productsGrid = resultsEl && resultsEl.querySelector('ul');
    const paginationNav = resultsEl && resultsEl.querySelector('nav');
    const pageFilters = document.querySelector('.main-products-grid__filters');
    const countBadge = document.querySelector('.collection-banner__count');

    const noResults = productCount === 0;

    if (noResults) {
      const config = getConfig();
      const fallbackHandle = isOntarioVisitor()
        ? config.ontarioFallbackCollectionURL
        : config.nonOntarioFallbackCollectionURL;

      const link = banner.querySelector('.js-province-banner-link');
      if (link && fallbackHandle) {
        link.href = fallbackHandle;
      } else if (link) {
        link.hidden = true;
      }
    }

    banner.hidden = !noResults;
    if (productsGrid) productsGrid.hidden = noResults;
    if (paginationNav) paginationNav.hidden = noResults;
    if (countBadge) countBadge.hidden = noResults;
    if (pageFilters) pageFilters.hidden = noResults;
  }

  function checkProductPageAccess() {
    const config = getConfig();
    const productTags = config.productTags;

    if (!Array.isArray(productTags)) return;

    const requiredTag = isOntarioVisitor() ? 'PROV' : 'FED';
    const hasTag = productTags.some(
      (tag) => String(tag).toUpperCase() === requiredTag
    );

    log('checkProductPageAccess: requiredTag=', requiredTag, 'productTags=', productTags, 'hasTag=', hasTag);
    if (!hasTag) {
      // Its FED/PROV twin or the search when province routing can work it out (see
      // recoverPage in province-routing.js), the homepage otherwise.
      const routing = window.PVRouting;
      if (routing && typeof routing.recoverPage === 'function' && routing.recoverPage(requiredTag)) {
        log('checkProductPageAccess: product ineligible, sending to its twin or search');
        return;
      }
      log('checkProductPageAccess: redirecting to homepage (product ineligible)');
      window.location.replace(window.theme.routes.root);
    }
  }

  function runProvinceFilter() {
    if (!isEnabled()) {
      log('runProvinceFilter: disabled');
      return;
    }

    log('runProvinceFilter: province=', document.body.dataset.province || '(none / non-Canada)');
    applyProvinceSections();

    if (!document.body.dataset.province) {
      log('runProvinceFilter: no province set, skipping nav/tag/product redirect');
      return;
    }

    applyProvinceNav();
    applyCollectionTagFilter();
    checkProductPageAccess();
  }

  document.addEventListener('on:province:detected', runProvinceFilter);

  document.addEventListener('on:collection:filtered', function (evt) {
    if (!isEnabled()) return;
    applyCollectionTagFilter();
  });

  document.addEventListener('DOMContentLoaded', function () {
    applyProvinceNav();
    applyProvinceSections();
    runProvinceFilter();
  });
})();
